/**
 * Capacitor-only bootstrap. Runs once on app load.
 * - Hides the native splash after a brief moment so the cream page fades in cleanly.
 * - Sets the iOS status bar style to match the cream Bible-page UI.
 * - No-op when running in a normal browser (Capacitor.isNativePlatform = false).
 */
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";

export async function initNative() {
  if (!Capacitor.isNativePlatform || !Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark }); // dark text on cream page
    await StatusBar.setBackgroundColor({ color: "#D4C5A0" });
  } catch {
    /* StatusBar plugin unavailable on this platform — ignore */
  }
  try {
    // small grace period so React has finished its first paint
    setTimeout(() => SplashScreen.hide().catch(() => {}), 400);
  } catch {
    /* ignore */
  }
}
